import React from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { useAuthenticationGuard } from "../../utils/useAuthenticationGuard";
import Navigation from "../elements/navigation/NavigationContainer";
import LoginContainer from "../login/LoginContainer";
import NotFound from "../notFound/NotFound";
import { StyledMainContainer } from "../styles/styledMain";

const Layout = ({ authentication, setAuthentication, authRouteRender }) => {
  const history = useHistory();

  useAuthenticationGuard(history);

  return (
    <>
      {authentication && <Navigation setAuthentication={setAuthentication} />}
      <StyledMainContainer auth={authentication}>
        <Switch>
          <Route
            path="/login"
            exact
            render={() =>
              authentication ? (
                <Redirect to="/" />
              ) : (
                <LoginContainer />
              )
            }
          />
          {authRouteRender()}
          {!authentication && <Redirect to="/login" />}
          <Route path="*" render={() => <NotFound />} />
        </Switch>
      </StyledMainContainer>
    </>
  );
};

export default Layout;